import { footer } from '../modules/sections/footer/index';

footer();
